import React, { createContext, useContext, useState, useEffect } from 'react';
import '../shared/styles/snackbar.css';

const SnackbarContext = createContext();

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    show: false,
    message: '',
    type: 'error',
    timer: null
  });

  const showSnackbar = (message, type = 'error', duration = 3000) => {
    if (snackbar.timer) {
      clearTimeout(snackbar.timer);
    }

    const timer = setTimeout(() => {
      setSnackbar(prev => ({ ...prev, show: false, timer: null }));
    }, duration);

    setSnackbar({
      show: true,
      message,
      type,
      timer
    });
  };

  useEffect(() => {
    return () => {
      if (snackbar.timer) {
        clearTimeout(snackbar.timer);
      }
    };
  }, [snackbar.timer]);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      {snackbar.show && (
        <div className={`${snackbar.type === 'success' ? 'success-snackbar' : 'error-snackbar'}`}>
          {snackbar.message}
        </div>
      )}
    </SnackbarContext.Provider>
  );
};